var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2316_5927",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2316_5927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 41.5L44.625 23.875L41.125 20.375L27 34.5L19.875 27.375L16.375 30.875L27 41.5ZM30.5 55C27.0417 55 23.7917 54.3437 20.75 53.0312C17.7083 51.7187 15.0625 49.9375 12.8125 47.6875C10.5625 45.4375 8.78125 42.7917 7.46875 39.75C6.15625 36.7083 5.5 33.4583 5.5 30C5.5 26.5417 6.15625 23.2917 7.46875 20.25C8.78125 17.2083 10.5625 14.5625 12.8125 12.3125C15.0625 10.0625 17.7083 8.28125 20.75 6.96875C23.7917 5.65625 27.0417 5 30.5 5C33.9583 5 37.2083 5.65625 40.25 6.96875C43.2917 8.28125 45.9375 10.0625 48.1875 12.3125C50.4375 14.5625 52.2187 17.2083 53.5312 20.25C54.8437 23.2917 55.5 26.5417 55.5 30C55.5 33.4583 54.8437 36.7083 53.5312 39.75C52.2187 42.7917 50.4375 45.4375 48.1875 47.6875C45.9375 49.9375 43.2917 51.7187 40.25 53.0312C37.2083 54.3437 33.9583 55 30.5 55ZM30.5 50C36.0833 50 40.8125 48.0625 44.6875 44.1875C48.5625 40.3125 50.5 35.5833 50.5 30C50.5 24.4167 48.5625 19.6875 44.6875 15.8125C40.8125 11.9375 36.0833 10 30.5 10C24.9167 10 20.1875 11.9375 16.3125 15.8125C12.4375 19.6875 10.5 24.4167 10.5 30C10.5 35.5833 12.4375 40.3125 16.3125 44.1875C20.1875 48.0625 24.9167 50 30.5 50Z",
    fill: "#33B4A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6e10298cc2e181ea2328ab205ad06fd0.svg";
export { ForwardRef as ReactComponent };